import React from 'react';
import Container from '@material-ui/core/Container';
import { useParams, useHistory } from 'react-router-dom';
import { type LaunchDarklyFlags, withLaunchDarkly } from '../common/launchDarkly';
import NavHeader from '../common/navigation/NavHeader';
import FooterLinks from '../components/common/FooterLinks';
import { ActivityLog } from '../components/envelopeHistory/ActivityLog';
import { Summary } from '../components/envelopeHistory/Summary';
import { HeaderContext } from '../context/header-context';
import { getUsersGroups } from '../lib/api/account/accountApi';
import { preferencesUrl } from '../lib/environment-config';
import { useDispatch, useShallowSelector } from '../lib/reduxHooks';
import * as actions from '../store/envelopeHistory/actions';

export function EnvelopeHistory(props: { flags: LaunchDarklyFlags }) {
  const { flags } = props;
  const hideNavItems = flags && flags['hide-build-ui-elements'];
  const showPreferencesMenuItem = flags && flags['add-automatic-time-stamp-signatures-to-user-preferences'];

  const dispatch = useDispatch();
  const history = useHistory();
  const { id: envelopeId } = useParams<{ id: string }>();

  const store = useShallowSelector((state) => ({ settingsFetched: state.pageFrame.settingsFetched }));
  const headerContext = React.useContext(HeaderContext);

  React.useEffect(() => {
    dispatch(actions.fetch(envelopeId));

    headerContext.setContent(
      <NavHeader
        labelName="Envelope history"
        breadcrumb={{ name: 'Envelope Management', onClick: () => history.push('/envelopes') }}
        hideNavItems={hideNavItems}
        preferencesUrl={preferencesUrl}
        showPreferences={showPreferencesMenuItem}
        getUsersGroups={getUsersGroups}
        flags={flags}
      />
    );
    return () => {
      headerContext.setContent(null);
      dispatch(actions.reset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [store.settingsFetched]);

  return (
    <Container role="main">
      <Summary />
      <ActivityLog />
      <FooterLinks showSocialIcons />
    </Container>
  );
}

// eslint-disable-next-line import/no-default-export -- Fix this once we update our LaunchDarkly implementation.
export default withLaunchDarkly(EnvelopeHistory);
